import { ArrowDown, ArrowUp, ArrowUpDown } from "lucide-react";
import { TableHead } from "@/components/ui/table";
import type { AccountSort, AccountSortColumn } from "@/lib/accountListView";

interface SortableHeaderProps {
  column: AccountSortColumn;
  label: string;
  sort: AccountSort | null;
  onSort: (column: AccountSortColumn) => void;
}

export const SortableHeader = ({ column, label, sort, onSort }: SortableHeaderProps) => {
  const direction = sort?.column === column ? sort.direction : null;
  const Icon = direction === "asc" ? ArrowUp : direction === "desc" ? ArrowDown : ArrowUpDown;

  return (
    <TableHead
      aria-sort={direction === "asc" ? "ascending" : direction === "desc" ? "descending" : "none"}
    >
      {/* `TableHead` already sets font-medium and text-muted-foreground; this only
          adds the affordance. Colours stay on the semantic ramp rather than
          switching to the raw gray scale. */}
      <button
        type="button"
        onClick={() => onSort(column)}
        className="-mx-1 inline-flex items-center gap-1 rounded-md px-1 py-0.5 ring-offset-background transition-colors hover:text-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2"
      >
        {label}
        <Icon
          className={`h-3.5 w-3.5 ${direction ? "text-foreground" : "text-muted-foreground/50"}`}
          aria-hidden
        />
      </button>
    </TableHead>
  );
};
